

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FctlbformComponent } from './fctlbform.component';
import { FctlblistComponent } from './fctlblist.component';
import { FctlblistitemComponent } from './fctlblistitem.component';
import { FcbasicModule } from '../fcbasic/index.module';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule,
    FcbasicModule
  ],
  exports: [
    FctlbformComponent,
    FctlblistComponent,
    FctlblistitemComponent
  ],
  declarations: [
    FctlbformComponent,
    FctlblistComponent,
    FctlblistitemComponent
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class FctlbModule { }

